module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/star_silver-a2ba0fbfbac7a6b8755579f65a5285e5.svg";